import React from 'react';
interface HeaderTooltipProps {
  label: string;
}
export function HeaderTooltip({
  label
}: HeaderTooltipProps) {
  return <span role="tooltip" className="pointer-events-none absolute left-1/2 top-full z-50 mt-2 -translate-x-1/2 translate-y-0.5 whitespace-nowrap rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 text-xs font-bold text-ville-navy opacity-0 shadow-lg shadow-ville-navy/10 transition-[opacity,transform] duration-150 ease-ville group-hover:translate-y-0 group-hover:opacity-100 group-focus-visible:translate-y-0 group-focus-visible:opacity-100" data-id="element-1421" data-mp="2z2vo1p9ptbo">
      <span className="absolute -top-1 left-1/2 h-2 w-2 -translate-x-1/2 rotate-45 border-l border-t border-slate-200 bg-white" aria-hidden="true" data-id="element-1422" data-mp="gz3tf8a8kkmx" />
      {label}
    </span>;
}